export const CloseModal = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.95703 3.95898L16.0404 16.0423M16.0404 3.95898L3.95703 16.0423"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)

export default CloseModal
